export const COLORS = {
    "light pink": "hsl(300, 100%, 87%)",
    "hot pink": "hsl(336, 100%, 50%)",
    coral: "hsl(348, 89%, 63%)",
    maroon: "hsl(0, 100%, 25%)",
    orange: "hsl(16, 100%, 66%)",
    yellow: "hsl(42, 100%, 53%)",
    "dark green": "hsl(60, 40%, 33%)",
    "light blue": "hsl(178, 98%, 78%)",
    teal: "hsl(180, 100%, 25%)",
    lavender: "hsl(260, 100%, 75%)",
    white: "hsl(0, 0%, 95%)",
    grey: "hsl(0, 0%, 66%)",
    black: "hsl(0, 0%, 6%)",
    multicolored:
        "linear-gradient(0deg, rgba(255,69,69,1) 0%, rgba(237,177,58,1) 18%, rgba(237,240,70,1) 37%, rgba(48,236,99,1) 56%, rgba(48,164,236,1) 73%, rgba(226,48,236,1) 96%)",
}

// true if color is light
export const COLORS_CONTRAST = {
    "light pink": true,
    "hot pink": true,
    coral: true,
    maroon: false,
    orange: true,
    yellow: true,
    "dark green": false,
    "light blue": true,
    teal: false,
    lavender: true,
    white: true,
    grey: true,
    black: false,
    multicolored: true,
}

export const COLORS_AVAILABILITY = {
    "light pink": true,
    "hot pink": true,
    coral: true,
    maroon: true,
    orange: true,
    yellow: true,
    "dark green": true,
    "light blue": false,
    teal: true,
    lavender: true,
    white: true,
    grey: true,
    black: true,
    multicolored: true,
}
